export const warningTime = {
  AS_SOON_AS_CREATE_TASK: { label: 'Topshiriq_yaratilishi_bilanoq' },
  ONE_DAY_AGO: { label: 'Topshiriq_boshlanish_vaqtidan_1_kun_oldin' },
  ONE_HOUR_AGO: { label: 'Topshiriq_boshlanishidan_1_soat_oldin' },
  THREE_DAYS_AGO: { label: 'Topshiriq_boshlanishidan_3_kun_oldin' }
};
